import types from '../types';

const projects = (
  state = {
    data: null,
    loading: true,
  },
  { type, payload },
) => {
  switch (type) {
    case types.GET_PROJECT_START:
      return { ...state, loading: true };

    case types.GET_PROJECT_SUCCESS:
      return { ...state, data: payload, loading: false };

    case types.GET_PROJECT_FAILURE:
      return { ...state, loading: false };

    case types.GET_PROJECT_ACCOUNT_START:
      return { ...state, loading: true };

    default:
      return state;
  }
};

export default projects;
